import { ProductStatusReadOut } from '../models/product-status-read-out';
import * as dayjs from 'dayjs';
import { Dayjs } from 'dayjs';
import { getDisplayVendorMessage } from './product-summary.utils';
import { ProductPropertiesEnum } from '@usf/product-types/Product-Summary';
import { Product } from '@shared/models/product.model';

export const buildProductStatusReadOut = (
  product: Product,
  currentDate = dayjs(),
): ProductStatusReadOut => {
  if (
    product?.summary?.properties?.has(ProductPropertiesEnum.direct) &&
    !product?.summary?.properties?.has(ProductPropertiesEnum.discontinued) &&
    !product?.summary?.properties?.has(ProductPropertiesEnum.supplierOutOfStock)
  ) {
    return buildDirectAndNotDiscontinuedReadOut(product, currentDate);
  }

  if (product?.summary?.properties?.has(ProductPropertiesEnum.ces)) {
    return buildCesReadOut(product);
  }

  if (product?.summary?.properties.has(ProductPropertiesEnum.dwo)) {
    return buildDwoReadOut();
  }

  return {
    display: false,
    primaryText: '',
  };
};

const buildDirectAndNotDiscontinuedReadOut = (
  product: Product,
  currentDate: Dayjs,
): ProductStatusReadOut => {
  const ret: ProductStatusReadOut = {
    primaryText: '',
    secondaryText: '',
    date: '',
    display: true,
  };

  const targetDate = currentDate.add(product?.inventory?.vendorLeadTime, 'day');
  if (targetDate.isValid()) {
    ret.date = targetDate.format('MM/DD');
    ret.primaryText = 'i18n.productDetail.readOut.directOrderTodayMessage';
  } else {
    ret.date = '';
    ret.primaryText =
      'i18n.productDetail.readOut.directOrderTodayInvalidDateMessage';
  }

  if (product?.summary?.returnable !== 'Y') {
    ret.secondaryText += 'i18n.productDetail.readOut.directNoReturnsMessage';
  }

  return ret;
};

const buildCesReadOut = (product): ProductStatusReadOut => ({
  display: true,
  primaryText: getDisplayVendorMessage(product),
  truncate: true,
});

const buildDwoReadOut = (): ProductStatusReadOut => ({
  display: true,
  primaryText: 'Discontinued When Out.',
  displayInFlyOut: true,
});
